<template>
  <div id="add-user" class="m-t-10">
    <form action="#" v-on:submit.prevent="submitForm" class="mr-1">
      <div class="form-group">
        <table class="table table-bordered" id="listStreamTable" width="100%">
          <thead>
            <tr>
              <th>Judul</th>
              <th>Media</th>
              <th>Tanggal</th>
              <th>Link</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>

      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import gp from "@/plugins/generalPlugins.js";

$.pgNotification = notif;

export default {
  name: "ViewStream",
  components: {},
  props: {
    data: Array,
  },
  data() {
    return {
      q: null,
      id_trend: this.data[0].idTrend,
      dataBerita: {},
      page_info: null,
      pagination_key: 0,
      dataStream: [],
    };
  },
  methods: {
    dateindo: function (tanggal) {
      return gp.dateTimeID(tanggal);
    },
    clickCheckbox: function (idStream) {
      var index = this.dataStream.indexOf(idStream);
      if (index != -1) {
        this.dataStream.splice(index, 1);
      } else {
        this.dataStream.push(idStream);
      }
    },
    checkData: function (idStream) {
      var index = this.dataStream.indexOf(idStream);
      let status = false;
      if (index != -1) {
        status = true;
      }
      return status;
    },
    getData: function () {
      let self = this;
      let urlParent = window.location.origin;
      let api =
        process.env.VUE_APP_API_URL + "newstrend/streams/" + this.id_trend;
      this.$http.get(api).then(function (response) {
        if (response.status == 204) {
          self.dataBerita = {};
          self.page_info = null;
        } else {
          self.table.clear();
          self.dataBerita = response.data.streams_list;
          for (let index in self.dataBerita) {
            let date = gp.dateTimeID(self.dataBerita[index].date.$date);
            let urlMediaTv =
              urlParent + "/view?id=" + self.dataBerita[index]._id.$oid;
            let url =
              self.dataBerita[index].source == "media_cetak" ||
              self.dataBerita[index].source == "media_tv"
                ? urlMediaTv
                : self.dataBerita[index].url;
            let btn =
              " <a href='" +
              url +
              "'target='_blank' class='btn btn-primary'> <i class='bi bi-box-arrow-up-right mr-1' ></i> Kunjungi Berita</a>";
            let title;
            if ("title" in self.dataBerita[index]) {
              title = self.dataBerita[index].title;
            } else {
              title = self.dataBerita[index].account;
            }
            self.table.row
              .add([
                title ? title : "-",
                self.dataBerita[index].account,
                date,
                btn,
              ])
              .node().id = index;
            self.table.draw();
          }
        }
      });
    },
  },
  mounted: function () {
    let self = this;
    self.table = $("#listStreamTable").DataTable();
    this.getData();
  },
  watch: {
    $route() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>